<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{'targetGroup.new' | translate}}</span>
      <button mat-button class="mat-icon-button"
              (click)="dialogRef.close()"
              aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0">

    <form [formGroup]="form" class="width-100">
      <mat-form-field class="form-fields width-100">
        <mat-label>{{'event.title' | translate}}</mat-label>
        <input matInput formControlName="title">
      </mat-form-field>
      <mat-form-field class="form-fields width-100">
        <mat-label>{{'targetGroup.creditTarget' | translate}}</mat-label>
        <input matInput formControlName="creditTarget" type="number"
               min="0">
      </mat-form-field>
      <mat-form-field class="form-fields width-100">
        <mat-label>{{'targetGroup.maxTransfer' | translate}}</mat-label>
        <input matInput formControlName="maxTransfer" type="number"
               min="0">
      </mat-form-field>
    </form>
  </div>

  <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">

    <button mat-raised-button
            (click)="dialogRef.close(form)"
            class="save-button mat-accent"
            [disabled]="form?.invalid"
            aria-label="SAVE">
      {{'main.save' | translate}}
    </button>

    <button mat-button
            class="mat-icon-button"
            (click)="dialogRef.close(false)"
            aria-label="Cancel"
            matTooltip="Cancel">
      {{'main.cancel' | translate}}
    </button>

  </div>
</div>
